<template>
    <AuthLayout>
        <router-view></router-view>
    </AuthLayout>
</template>

<script setup lang="ts">
import AuthLayout from '@/components/layouts/AuthLayout.vue';
</script>
